import React from "react";
import {
    Dialog,
    DialogContent,
    Box,
    Typography,
    Button,
    styled
} from "@mui/material";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 16,
        boxShadow: theme.shadows[5],
        width: "420px",
        maxWidth: "90%",
        padding: '36px',
        backgroundColor: '#FFF1F1',
        border: '1px solid #FF7F7A'
    },
}));

const ErrorModal = ({ open, onClose, errorMessage, buttonText = "Go Back to Uploads", onButtonClick }) => {
    const handleButtonClick = () => {
        if (onButtonClick) {
            onButtonClick();
        }
        onClose();
    };

    return (
        <StyledDialog open={open} onClose={onClose}>
            <DialogContent sx={{ p: 0 }}>
                {/* Error Icon */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
                    <CancelOutlinedIcon sx={{ fontSize: 40, color: '#B50500' }} />
                </Box>

                {/* Error Title */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
                    <Typography
                        variant="fw600s16c000000"
                        sx={{
                            fontSize: '18px',
                            lineHeight: '18px',
                            color: '#D00000'
                        }}
                    >
                        Error
                    </Typography>
                </Box>

                {/* Error Message */}
                <Box sx={{ mb: 4.5, display: 'flex', justifyContent: 'center' }}>
                    <Typography
                        variant="fw400s14c000000"
                        sx={{
                            textAlign: 'center',
                            lineHeight: '22px'
                        }}
                    >
                        {errorMessage || 'An unexpected error occurred. Please try again.'}
                    </Typography>
                </Box>

                {/* Action Button */}
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        onClick={handleButtonClick}
                        sx={{
                            borderRadius: '8px',
                            padding: '8px 24px',
                            textTransform: 'none',
                            fontSize: '14px',
                            lineHeight: '22px',
                            fontWeight: 600,
                            color: '#FFFFFF',
                            backgroundColor: '#494949',
                            '&:hover': {
                                // backgroundColor: '#424242',
                            }
                        }}
                    >
                        {buttonText}
                    </Button>
                </Box>
            </DialogContent>
        </StyledDialog>
    );
};

export default ErrorModal;
